import { render, staticRenderFns } from "./TitleBox.vue?vue&type=template&id=a740fe16&scoped=true&"
import script from "./TitleBox.vue?vue&type=script&lang=js&"
export * from "./TitleBox.vue?vue&type=script&lang=js&"
import style0 from "./TitleBox.vue?vue&type=style&index=0&id=a740fe16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a740fe16",
  null
  
)

export default component.exports